import { render } from "./SendgridLogoIcon.vue?vue&type=template&id=c8a51358"
import script from "./SendgridLogoIcon.vue?vue&type=script&lang=js"
export * from "./SendgridLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__